import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=3b5c699a&scoped=true"
import script from "./footerNav.vue?vue&type=script&lang=js"
export * from "./footerNav.vue?vue&type=script&lang=js"
import style0 from "./footerNav.vue?vue&type=style&index=0&id=3b5c699a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c699a",
  null
  
)

export default component.exports